import React from 'react';
import { ButtonColor, Form, FormSubmitType } from '@doveit/lego';
import schema from './LeadForm.schema';
import FormAddressAutoComplete from '../form-address-autocomplete/FormAddressAutoComplete';
import { AddressSuggestion } from '../../services/geo/geo';

export interface LeadFormModel {
  name: string,
  phoneNumber: string,
  address: string,
  placeId?: string,
  email?: string,
  consent: boolean,
}

export interface LeadFormProps {
  dataRef?: string,
  dataTracking?: string,
  onSubmit: FormSubmitType<LeadFormModel>,
  loading?: boolean,
  errorMessage?: string,
  successMessage?: string,
}

const DEFAULT_VALUES: LeadFormModel = {
  name: '',
  phoneNumber: '',
  address: '',
  email: '',
  placeId: undefined,
  consent: false,
};

const LeadForm: React.FC<LeadFormProps> = ({
  dataRef = 'lead-form',
  dataTracking,
  onSubmit,
  loading,
  errorMessage,
  successMessage,
}) => (
  <Form
    initialValues={{ ...DEFAULT_VALUES }}
    onSubmit={onSubmit}
    validationSchema={schema}
    loading={loading}
  >{({ setFieldValue }) => {
    const onSuggestionChange = () => setFieldValue('placeId', '');
    const onSuggestionSelected = (suggestion: AddressSuggestion) => setFieldValue('placeId', suggestion.placeId);

    return (
      <>
        <Form.Item>
          <Form.Input
            name="name"
            label="Il tuo nome"
            aria-label="Campo per inserire il tuo nome e cognome"
            placeholder="Es. Mario Rossi"
            required
          />
        </Form.Item>
        <Form.Item>
          <FormAddressAutoComplete
            id="lead-address"
            name="address"
            label="Dove si trova l'immobile?"
            aria-label="Campo per inserire indirizzo dell'immobile"
            placeholder="Es. Via Nino Bixio, 7, Milano"
            required
            onChange={onSuggestionChange}
            onSuggestionSelected={onSuggestionSelected}
          />
        </Form.Item>
        <Form.Item>
          <Form.Input
            type="tel"
            name="phoneNumber"
            label="Il tuo numero di telefono"
            aria-label="Campo per inserire il tuo numero di telefono"
            placeholder="Es. 3381234321"
            required
          />
        </Form.Item>
        <Form.Item>
          <Form.Input
            type="email"
            name="email"
            label="Il tuo indirizzo email"
            aria-label="Campo per inserire la tua email"
            placeholder="Es. mario.rossi@gmail.com"
          />
        </Form.Item>
        {errorMessage && (
          <Form.Item>
            <Form.ErrorMessage message={errorMessage} />
          </Form.Item>
        )}
        {successMessage && (
          <Form.Item>
            <Form.SuccessMessage message={successMessage} />
          </Form.Item>
        )}
        <Form.Item>
          <Form.Checkbox
            name="consent"
            text="Accetto i termini del servizio e informativa privacy"
            aria-label="Consenso per il trattamento dei dati"
          />
        </Form.Item>
        <Form.Item>
          <Form.Submit
            dataRef={`${dataRef}-submit`}
            dataTracking={dataTracking}
            color={ButtonColor.SECONDARY}
            label="Richiedi informazioni"
            aria-label="Richiedi informazioni"
            expanded
          />
        </Form.Item>
      </>
    );
  }}
  </Form>
);

export default LeadForm;
